import store from "../store";

// get the trim all data before open the Editor page
export async function getTrimData(to, from, next) {
    const params = to.params;
    const url = params['trimName'];
    const trimIdMatches = url.match(/[0-9]+/);
    const trimId = trimIdMatches && +trimIdMatches[0];

    if (!trimId) {
        next('/');

        return;
    }

    await store.dispatch('trims/setCurrentTrimToEditor', trimId);

    next();
}

// get trims taking into account a search query and pagination page
export async function getTrims(to, from, next) {
    // pagination page
    const { page = 1 } = to.query;

    const mainParams = {};
    const searchParams = {};

    // apply trims pagination options
    await store.dispatch('trims/applyPagination');

    // update pagination
    await store.dispatch('pagination/setPage', page);

    // get trims before enter to the Trims page
    await store.dispatch('trims/getTrimsByQuery', { mainParams, searchParams, page });

    next();
}

// trims of the currently authorized user
export async function getUserTrims(to, from, next) {
    const { page = 1 } = to.query;
    const userId = store.state.authentication['userId'];

    // Validate authentication state
    if (!store.state.authentication['authenticationStatus']) {
        next({ name: 'unauthorized' });
        return;
    }

    if (!userId) {
        next('/trims');
        return;
    }

    const mainParams = { userId };
    const searchParams = {};

    // apply trims pagination options
    await store.dispatch('trims/applyPagination');

    // update pagination
    await store.dispatch('pagination/setPage', page);

    // get the user Trims before enter to the user trims page
    await store.dispatch('trims/getTrimsByQuery', { mainParams, searchParams, page });

    next();
}

// trims of the selected user
export async function getUserCreatedTrims(to, from, next) {
    // pagination page
    const { page = 1 } = to.query;

    // Validate authentication state for admin functionality
    if (!store.state.authentication['authenticationStatus']) {
        next({ name: 'unauthorized' });
        return;
    }

    const userId = store.state.users['currentUserId'];

    if (!userId) {
        next('/users');
        return;
    }

    const mainParams = { userId };
    const searchParams = {};

    // apply trims pagination options
    await store.dispatch('trims/applyPagination');

    await store.dispatch('pagination/setPage', page);

    await store.dispatch('trims/getTrimsByQuery', { mainParams, searchParams, page });

    next();
}

export async function getUsers(to, from, next) {

    // Validate authentication state for admin functionality
    if (!store.state.authentication['authenticationStatus']) {
        next({ name: 'unauthorized' });
        return;
    }

    await store.dispatch('users/getUsers');

    next();
}

export async function getUser(to, from, next) {
    const params = to.params;
    const url = params['userName'];
    const userIdMatches = url.match(/[0-9]+/);
    const userId = userIdMatches && +userIdMatches[0];

    // Validate authentication state for admin functionality
    if (!store.state.authentication['authenticationStatus']) {
        next({ name: 'unauthorized' });
        return;
    }

    if (!userId) {
        next('/users');
        return;
    }

    // get user data
    let currentUser = await store.dispatch('users/getUser', userId);

    if (currentUser) {

        // set current user id
        store.commit('users/setCurrentUserId', userId);
    }
    else {
        next('/users');
        return;
    }

    next();
}

export async function getSettings(to, from, next) {

    // Validate authentication state for admin functionality
    if (!store.state.authentication['authenticationStatus']) {
        next({ name: 'unauthorized' });
        return;
    }

    await store.dispatch('saveSettings/getSaveSettings');

    next();
}